import styled from 'styled-components';
import { getUrlWithToken } from '../../../utils/common';

export const Cover = styled.div`
  width: 100%;
  height: 436px;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-position: center center;
  background-size: cover;
  margin-bottom: 32px;
  &::after {
    content: '';
    display: block;
    width: inherit;
    height: inherit;
    background: linear-gradient(
      360deg,
      #050505 -42.43%,
      rgba(255, 255, 255, 0) 102.81%
    );
  }
`;

export const Date = styled.div`
  color: #515151;
`;
